<template>
  <v-card flat>
    <v-card-title primary-title>
      <h3 class="display-1 mb-0">Profileinstellungen</h3>
    </v-card-title>
    
      
<v-card-text>
      <form v-on:submit="saveForm()">
        <v-layout row>
          <v-flex xs4>
            <v-subheader>Farbe</v-subheader>

          </v-flex>
          <v-flex
            xs8
            lg8
          >

            <swatches
              v-model="betrieb.profilfarbe"
              inline
              colors="material-light"
            />

            <swatches
              v-model="betrieb.profilfarbe"
              inline
              colors="material-basic"
            />

            <swatches
              v-model="betrieb.profilfarbe"
              inline
              colors="material-dark"
            />

            <v-text-field
              name="farbe"
              label="Genaue Farbe (Leerlassen für Standard)"
              v-model="betrieb.profilfarbe"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
        >

          <v-flex xs4>
            <v-subheader>Dunkler Text</v-subheader>

          </v-flex>
          <v-flex xs8>
            <v-checkbox
              label="Dunkler Text"
              v-model="betrieb.profildark"
            ></v-checkbox>

          </v-flex>

          <v-flex xs4>
            <v-subheader>Transparenz des Headers<br>
              Standardwert: 60% </v-subheader>

          </v-flex>
          <v-flex xs5>
            <v-slider
              v-model="betrieb.profilopacity"
              label=""
              :max="1"
              :min="0.2"
              :step="0.05"
            ></v-slider>
          </v-flex>
          <v-flex
            xs2
            offset-xs1
          >

            <v-text-field
              v-model="betrieb.profilopacity"
              class="mt-0"
              type="number"
            ></v-text-field>
          </v-flex>

          <v-divider></v-divider>
          <v-flex xs4>
            <v-subheader>Abstand des Titels (für große Bilder)<br> Standardwert: 550px</v-subheader>

          </v-flex>
          <v-flex xs5>
            <v-slider
              v-model="betrieb.profilabstand"
              :max="900"
              :min="400"
              label=""
              always-dirty
            ></v-slider>
          </v-flex>
          <v-flex
            xs2
            offset-xs1
          >

            <v-text-field
              v-model="betrieb.profilabstand"
              class="mt-0"
              type="number"
            ></v-text-field>
          </v-flex>

        </v-layout>

 

        
    <v-layout row class="mt-3">
       <v-flex xs4>
        &nbsp;
       </v-flex>
       <v-flex xs4 class="text-xs-center">
        <v-btn v-on:click.native="saveForm()" large color="accent">Speichern</v-btn>
       </v-flex>
       <v-flex xs4 class="text-xs-right">
          <v-btn @click="nexttab()" large>Weiter <v-icon right>chevron_right</v-icon></v-btn>
       </v-flex>
    </v-layout>

      </form>

    </v-card-text>
  </v-card>
</template>

<script>
import BildUpload from '~/components/meinbetrieb/BildUpload.vue'
import BildListe from '~/components/meinbetrieb/BildListe.vue'
import axios from 'axios'
import Swatches from 'vue-swatches'

// Import the styles too, globally
import 'vue-swatches/dist/vue-swatches.min.css'

export default {
  components: {
    // StripePay,
    BildUpload,
    BildListe,
    Swatches
  },
  props: {
    betrieb: ''
  },
  // window.VueSwatches.default - from CDN
  data () {
    return {
      color: '#1CA085',
      checkbox: false
    }
  },
  methods: {
    nexttab (event) {
      this.$emit('tabswitch')
    },
    saveForm () {
      var app = this
      var newCompany = app.betrieb

      axios
        .patch('/api/v1/companies/' + app.betrieb.id, newCompany)
        .then((resp) => {
          this.$store.dispatch('responseMessage', {
            type: 'success',
            text: this.$t('betrieb_updated')
          })
          // app.$router.replace('/meinbetrieb')
        })
        .catch((resp) => {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: this.$t('error_alert_text')
          })
        })
    }
  }
}
// import 'babel-polyfill'; // es6 shim
</script>